/* E3 Rewards — claim page client. Plan 2.
   Reads ?ct=, POSTs /claim/confirm, renders: reveal | redeemed | expired | error.

   "Spray Booth" direction (owner's pick 2026-08-09): the reveal state throws
   paint flecks and uncovers the discount with a sweep. The other three states
   never celebrate — no confetti, no sweep, no overspray. */
(function () {
  'use strict';

  var root = document.getElementById('e3-claim');
  if (!root) return;
  var card = root.querySelector('.e3-claim__card');
  var api = root.dataset.api;
  var ct = new URLSearchParams(location.search).get('ct');

  var reduced = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render(state, html) {
    card.dataset.state = state;
    card.innerHTML = html;
  }

  /* ------------------------------------------------------------------
     Paint flecks.
     Colours are read from e3-tokens.css at runtime rather than repeated
     here, so a token change moves the confetti with it.
  ------------------------------------------------------------------ */
  function fleckColors() {
    var cs = getComputedStyle(document.documentElement);
    return ['--e3-teal', '--e3-teal-lift', '--e3-blue', '--e3-on-dark']
      .map(function (name) { return cs.getPropertyValue(name).trim(); })
      .filter(Boolean);
  }

  function throwFlecks() {
    if (reduced) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'e3-claim__confetti';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = canvas.clientWidth, h = canvas.clientHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    var g = canvas.getContext('2d');
    if (!g) { canvas.remove(); return; }
    g.scale(dpr, dpr);

    /* thrown from the middle of the card, not the middle of the screen */
    var r = card.getBoundingClientRect();
    var ox = r.left + r.width / 2;
    var oy = r.top + r.height / 2;

    var colors = fleckColors();
    var parts = [], i;

    for (i = 0; i < 110; i++) {
      var ang = Math.random() * Math.PI * 2;
      var sp = 11 * (0.55 + Math.random() * 0.75);
      parts.push({
        x: ox, y: oy,
        vx: Math.cos(ang) * sp,
        vy: Math.sin(ang) * sp,
        rot: Math.random() * Math.PI * 2,
        vr: (Math.random() - 0.5) * 0.34,
        rad: 1.6 + Math.random() * 2.8,
        color: colors[(Math.random() * colors.length) | 0],
        life: 120 * (0.7 + Math.random() * 0.5),
        age: 0
      });
    }

    function frame() {
      g.clearRect(0, 0, w, h);
      var alive = 0;

      for (i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.age++;
        if (p.age > p.life) continue;

        p.vy += 0.26;          /* gravity */
        p.vx *= 0.978;         /* drag */
        p.vy *= 0.978;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;

        if (p.y > h + 40) continue;
        alive++;

        var fade = p.age > p.life * 0.7
          ? 1 - (p.age - p.life * 0.7) / (p.life * 0.3)
          : 1;

        g.save();
        g.globalAlpha = Math.max(0, fade);
        g.translate(p.x, p.y);
        g.rotate(p.rot);
        g.fillStyle = p.color;
        g.beginPath();
        g.ellipse(0, 0, p.rad * 1.7, p.rad, 0, 0, Math.PI * 2);
        g.fill();
        g.restore();
      }

      if (alive > 0) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();   /* leave nothing behind once it has settled */
      }
    }

    requestAnimationFrame(frame);
  }

  /* ---------------------------- states ---------------------------- */

  function renderExpired() {
    render('expired',
      '<div class="e3-claim__rail"></div>' +
      '<h1 class="e3-claim__heading">This link has expired</h1>' +
      '<p class="e3-claim__note">Claim links are good for 24 hours. Play again on your next ' +
      'visit — the badge in the corner is always there.</p>' +
      '<a class="e3-claim__cta" href="/">Back to the store</a>');
  }

  function renderAlreadyRedeemed() {
    render('redeemed',
      '<div class="e3-claim__rail"></div>' +
      '<h1 class="e3-claim__heading">Already claimed</h1>' +
      '<p class="e3-claim__note">This code has been used. One prize per customer, and yours ' +
      'is already on its way to a build.</p>' +
      '<a class="e3-claim__cta" href="/">Back to the store</a>');
  }

  function renderError() {
    render('error',
      '<div class="e3-claim__rail"></div>' +
      '<h1 class="e3-claim__heading">We could not check that link</h1>' +
      '<p class="e3-claim__note">Something went wrong on our side, not yours. Refresh and it ' +
      'will usually clear.</p>' +
      '<a class="e3-claim__cta" href="javascript:location.reload()">Try again</a>');
  }

  /* ------------------------------------------------------------------
     Prize choice (2026-08-12).

     Shown only when the server says a decision is owed. It arrives BEFORE
     anything is minted, so picking here creates exactly one code — there is no
     spare to void and nothing to clean up.

     The wording carries real weight. The regret case is not "I picked wrong",
     it is "I did not realise I had 30 days" — someone takes the low minimum for
     today's small cart, then wants a bigger build next week. So the validity
     window is stated as emphasis, not as fine print, and the minimum is the
     loudest thing on each card because it is the number that decides whether a
     prize is usable at all.
  ------------------------------------------------------------------ */
  function money(v) {
    /* "500.00" -> "$500"; keeps cents only when they are not .00 */
    var n = parseFloat(v);
    if (isNaN(n)) return '$' + String(v);
    return '$' + (n % 1 === 0 ? String(n) : n.toFixed(2));
  }

  function renderChoose(body) {
    var opts = body.options || [];
    var days = body.validForDays || 30;

    var cards = opts.map(function (o, i) {
      var best = i === 0;
      return '<button type="button" class="e3-claim__pick" data-tier="' + esc(o.tier) + '"' +
        (best ? ' data-best="1"' : '') + '>' +
          (best ? '<span class="e3-claim__pick-flag">You earned this</span>' : '') +
          '<span class="e3-claim__pick-amount">' + esc(money(o.amount)) + ' off</span>' +
          '<span class="e3-claim__pick-min">when you spend ' +
            esc(money(o.minimumSubtotal)) + ' or more</span>' +
        '</button>';
    }).join('');

    /* Owner-authored copy, 2026-08-12. Deliberately count-agnostic: it says
       "the code that best fits your spend" rather than naming two or three, so
       the same wording holds whatever a tier offers. Do not reintroduce a
       per-tier variant. */
    render('choose',
      '<p class="e3-claim__kicker">Nice work in the booth</p>' +
      '<h1 class="e3-claim__heading">Pick your reward</h1>' +
      '<p class="e3-claim__note">You&rsquo;ve unlocked the <u>BIGGER</u> discount. ' +
      'Don&rsquo;t want to spend that much today? No problem!</p>' +
      '<p class="e3-claim__note">Simply choose the one that best fits your desired spend.</p>' +
      '<div class="e3-claim__picks">' + cards + '</div>' +
      '<p class="e3-claim__weigh">Codes are valid for <u>' + days + ' days</u>. ' +
      'Plan ahead and choose wisely&hellip;</p>' +
      '<p class="e3-claim__final">You are only able to choose <b>one code</b>, and this ' +
      'choice <b>cannot</b> be changed later.</p>');

    Array.prototype.forEach.call(card.querySelectorAll('.e3-claim__pick'), function (btn) {
      btn.addEventListener('click', function () {
        /* Lock the whole set immediately: a double-tap must not fire two
           confirms, and the second would return the first code anyway. */
        Array.prototype.forEach.call(card.querySelectorAll('.e3-claim__pick'), function (b) {
          b.disabled = true;
        });
        btn.dataset.busy = '1';
        confirmClaim(btn.dataset.tier);
      });
    });
  }

  function renderReveal(body) {
    var expires = new Date(body.expiresAt).toLocaleDateString(undefined, {
      year: 'numeric', month: 'long', day: 'numeric',
    });

    render('reveal',
      '<p class="e3-claim__kicker">Nice work in the booth</p>' +
      '<h1 class="e3-claim__heading">' +
        (body.status === 'existing' ? 'Your active code' : 'You earned it') +
      '</h1>' +
      '<p class="e3-claim__tier">' + esc(body.label) + '</p>' +
      '<div class="e3-claim__code-row">' +
        '<code class="e3-claim__code">' + esc(body.code) + '</code>' +
        '<button type="button" class="e3-claim__copy">Copy</button>' +
      '</div>' +
      '<p class="e3-claim__note">Apply it at checkout. Valid through ' + esc(expires) + '.</p>' +
      '<a class="e3-claim__cta" href="/">Start shopping</a>');

    card.querySelector('.e3-claim__copy').addEventListener('click', function () {
      var btn = this;
      navigator.clipboard.writeText(body.code).then(function () {
        btn.textContent = 'Copied!';
        setTimeout(function () { btn.textContent = 'Copy'; }, 2000);
      });
    });

    /* one frame later, so the card has been laid out and the flecks are
       thrown from where it actually is */
    requestAnimationFrame(throwFlecks);
  }

  if (!ct) { renderExpired(); return; }

  /* One request shape for both passes. Without `choice` the server answers
     "choose" for a tier that owes a decision and mints nothing; with a valid
     `choice` it mints. A floor-tier winner has nothing to decide, so their first
     call mints exactly as it always did — no extra click for them. */
  function confirmClaim(choice) {
    var payload = { ct: ct };
    if (choice) payload.choice = choice;

    return fetch(api + '/claim/confirm', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (res.status === 410) { renderExpired(); return null; }
      if (!res.ok) { renderError(); return null; }
      return res.json();
    }).then(function (body) {
      if (!body) return;
      if (body.status === 'already_redeemed') { renderAlreadyRedeemed(); return; }
      if (body.status === 'choose') { renderChoose(body); return; }
      renderReveal(body);
    }).catch(renderError);
  }

  confirmClaim(null);
})();
